// TICKET-2341: the vendor list holds hundreds of vendors, and only some are Active. Users picked the
// first (often invalid) one, so the dropdown offers only Active vendors, A-Z (Earl, 2 Nov 2026).
// The API still returns every vendor: existing records resolve their vendor's name from that list.
// A record already linked to a non-Active vendor keeps it in its own dropdown, labelled with its
// status, so opening the form does not blank the field.

const ACTIVE = 1;

const STATUS_NAMES = {
  2: "Inactive",
  10: "Expired",
};

export const vendorLabel = (vendor) => {
  const name = vendor.name || "";

  if (vendor.status_id === ACTIVE) {
    return name;
  }

  return STATUS_NAMES[vendor.status_id] ? name + " (" + STATUS_NAMES[vendor.status_id] + ")" : name;
};

export const vendorDropdownOptions = (vendors, selectedIds = []) =>
  vendors
    .filter(vendor => vendor.status_id === ACTIVE || selectedIds.includes(vendor.id))
    .sort((a, b) => {
      const activeFirst = (b.status_id === ACTIVE) - (a.status_id === ACTIVE);

      return activeFirst !== 0
        ? activeFirst
        : (a.name || "").localeCompare(b.name || "", undefined, {sensitivity: "base"});
    });
